import { MultiSelectDesignTokens } from '@primeuix/themes/types/multiselect';

import { getColor, getRem } from '@customer-portal/shared/helpers/theme-utils';

export const multiselectOverride: MultiSelectDesignTokens = {
  root: {
    borderRadius: getRem(10),
    color: getColor('UiBlack'),
    background: getColor('UiWhite'),
    placeholderColor: getColor('PlaceholderGray'),
  },
  option: {
    selectedFocusBackground: getColor('WhiteSmoke'),
    selectedBackground: getColor('WhiteSmoke'),
    focusBackground: 'transparent',
    color: getColor('UiBlack'),
    gap: getRem(8),
    padding: `${getRem(0)} ${getRem(10)}`,
    borderRadius: getRem(10),
  },
  dropdown: {
    color: getColor('DarkBlue'),
  },
  overlay: {
    color: getColor('UiBlack'),
  },
  list: {
    padding: getRem(8),
    header: {
      padding: getRem(0),
    },
  },
};
